import React, { Component } from 'react'

class IconWarning extends Component {
  render() {
    return (
      <svg width="71" height="71">
        <path
          fill="#B13D47"
          fillRule="evenodd"
          d="M0 35.383C0 15.843 15.843 0 35.383 0c19.542 0 35.383 15.843 35.383 35.383 0 19.545-15.84 35.383-35.383 35.383C15.843 70.766 0 54.926 0 35.383zm6.634 0c0 15.878 12.87 28.749 28.749 28.749 15.878 0 28.749-12.871 28.749-28.75 0-15.877-12.871-28.748-28.75-28.748-15.877 0-28.748 12.87-28.748 28.749zm28.751-19.865c-2.534 0-4.451 1.322-4.451 3.458V38.57c0 2.138 1.917 3.456 4.451 3.456 2.473 0 4.452-1.373 4.452-3.456V18.976c0-2.085-1.98-3.458-4.452-3.458zm-4.416 35.34a4.422 4.422 0 0 1 4.416-4.418A4.42 4.42 0 0 1 39.8 50.86a4.42 4.42 0 0 1-4.414 4.414 4.421 4.421 0 0 1-4.416-4.415z"
          clipRule="evenodd"
        />
      </svg>
    )
  }
}

export default IconWarning



// WEBPACK FOOTER //
// ./src/svg/icon-warning.js